import PropTypes from 'prop-types';

export default function AutocompleteItem(props) {
	const { item, onClick, itemTemplate } = props;

	return <div>{itemTemplate(props)}</div>;
}

AutocompleteItem.propTypes = {
	item: PropTypes.any.required,
	itemTemplate: PropTypes.any.required,
	onClick: PropTypes.any.require,
};
